export default "__VITE_ASSET__CfAnmPYV__"